module.exports = __webpack_public_path__ + "static/top-tools-5770b0772a8bd608dd8deabe90a5676f.png";